module.exports = "/_next/static/pages/testing-environment/30ba7912b051c37f74e84087b7c0f1f5.png";